import React, { useState, useRef, useEffect } from "react";
import styles from "./TopicsPage.module.css";
import { useHistory } from "react-router-dom";
import group1 from "../assets/Group.svg";
import group2 from "../assets/Group (1).svg";
// import group3 from "../assets/Group (2).svg";
import Header from "../components/Header";
import rectangle from "../assets/Rectangle 2761.svg";
import check from "../assets/np_check_1438094_000000.svg";
import upload from "../assets/Upload Icon.svg";
import uploadSuccess from "../assets/Upload=Success.svg";
import uploadFail from "../assets/Upload=Failed.svg";
import { useAccount } from "utils/AccountInfoContext";
import { useTopics } from "./useTopics";

import { ChevronRight, ChevronDown, Refresh } from "react-ikonate";
import Button from "../components/Button";
import classNames from "classnames";
import Loader from "components/Loader";
import { useTranslation } from "react-i18next";

export function TopicsPage() {
  const {t} = useTranslation();
  const history = useHistory();
  const { usersData } = useAccount();
  const [selectedUsers, setSelectedUsers] = useState(
    usersData.filter((user) => user.topicsActivated).map((user) => user.userId)
  );

  const [uploadStatus, setUploadStatus] = useState(null);
  // const [uploadedFiles, setUploadedFiles] = useState(0);
  const fileInputRef = useRef(null);
  const { accountData } = useAccount();

  const iboNumber = accountData?.account?.ibo;

  const {
    uploadAudioFiles,
    uploadedAudioFiles,
    uploadedAudioFilesLoading,
    refetchUploadedAudioFiles,
    refetchingUploadedAudioFilesLoading,
    retryUploadForItem,
  } = useTopics();
  const [rootLoading, setRootLoading] = useState(false);
  const [topicsTab, setTopicsTab] = useState("upload");
  const [processingRequest, setProcessingRequest] = useState(false);
  const [uploadMore, setUploadMore] = useState(true);
  const [invalidFileTypeDropdown, setInvalidFileTypeDropdown] = useState(false);
  const [incorrectFiles, setIncorrectFiles] = useState([]);
  const [failedUploadDropdown, setFailedUploadDropdown] = useState(false);
  const [failedUploadFiles, setFailedUploadFiles] = useState([]);
  const [oversizeFiles, setOversizeFiles] = useState([]);

  const handleHeaderBackClick = () => {
    history.push("/");
  };

  const handleUserCheckboxChange = (userId) => {
    setSelectedUsers((prevSelectedUsers) =>
      prevSelectedUsers.includes(userId)
        ? prevSelectedUsers.filter((id) => id !== userId)
        : [...prevSelectedUsers, userId]
    );
  };

  const handleUploadClick = () => {
    // Reset previous upload status and uploaded files count
    setUploadStatus(null);
    // setUploadedFiles(0);
    setFailedUploadFiles([]);
    setIncorrectFiles([]);

    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleUploadFiles = async (event) => {
    const files = event.target.files;

    // Reset upload status and uploaded files count
    setUploadStatus(null);
    // setUploadedFiles(0);
    setFailedUploadFiles([]);
    setIncorrectFiles([]);
    setOversizeFiles([]);
    setProcessingRequest(true);

    if (!files || files.length === 0) {
      console.error("No files selected.");
      return;
    }

    const id =
      selectedUsers.length === usersData.length
        ? "all"
        : selectedUsers.length === 1
        ? usersData.find((user) => user.userId === selectedUsers[0])?.contactId
        : null;

    if (!id) {
      console.error("Invalid selection of users.");
      setUploadStatus("fail");
      return;
    }

    if (!iboNumber) {
      console.error("Missing IBO number in account data.");
      setUploadStatus("fail");
      return;
    }

    const filesArray = Array.from(files);

    const oversizeFiles = filesArray.filter(
      (file) => file.size > 15 * 1024 * 1024
    );

    if (oversizeFiles.length > 0) {
      setOversizeFiles(oversizeFiles);
      setProcessingRequest(false);
      return;
    }

    try {
      const result = await uploadAudioFiles.mutateAsync({
        id,
        fileData: filesArray,
      });

      //example response from the api to showcase types of errors and the render linking to them
      // let mockRes = {
      //   "fileTypeErrors": [
      //     {
      //       // "name": "Test Audio 1 JD super super super super super super super super super long message.m4a",
      //       "name": "Test Audio 1 JD.m4a",
      //       "type": "audio/mp4",
      //       "length": 163718
      //     },
      //     {
      //       // "name": "Test Audio 1 JD super super super super super super super super super long message.m4a",
      //       "name": "Test Audio 2 JD.m4a",
      //       "type": "audio/mp4",
      //       "length": 163718
      //     },
      //     {
      //       // "name": "Test Audio 1 JD super super super super super super super super super long message.m4a",
      //       "name": "Test Audio 3 JD.m4a",
      //       "type": "audio/mp4",
      //       "length": 163718
      //     },
      //   ],
      //   "microResponse": {
      //     "failedBlob": [
      //       {
      //         "status": "failed",
      //         "reason": "Forced Fail",
      //         "audioValue": {
      //           "name": "3000000075-1846178-4bd0dcc0-38e9-11f0-904f-6f6546da597a-Test-Audio-1-JD.mp3",
      //           "originalFileName": "Test-Audio-1-JD.mp3",
      //           "type": "audio/mpeg",
      //           "length": 80343
      //         }
      //       },
      //       {
      //         "status": "failed",
      //         "reason": "Forced Fail",
      //         "audioValue": {
      //           "name": "3000000075-1865315-4bd0dcc4-38e9-11f0-904f-6f6546da597a-Test-Audio-1-JD.mp3",
      //           "originalFileName": "Test-Audio-1-JD.mp3",
      //           "type": "audio/mpeg",
      //           "length": 80343
      //         }
      //       }
      //     ]
      //   }
      // }

      //utility fake api call function to simulate during development
      // await fakeApiCall(3000);

      // throw new Error("test");

      setUploadStatus("success");
      // setUploadedFiles(filesArray.length); // Update uploadedFiles to the length of uploaded files
      setFailedUploadFiles(result.microResponse.failedBlob);
      setIncorrectFiles(result.fileTypeErrors);

      setProcessingRequest(false);
      setUploadMore(false);
    } catch (error) {
      console.error("Upload failed:", error.message || error);
      setUploadStatus("fail");
      setProcessingRequest(false);
      setUploadMore(true);
    } finally {
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Reset file input
      }
    }
  };

  const handleInvalidFileTypeDropdownClick = () => {
    setInvalidFileTypeDropdown(!invalidFileTypeDropdown);
  };

  const handleFailedDropdownClick = () => {
    setFailedUploadDropdown(!failedUploadDropdown);
  };

  const handleBackClick = () => {
    setUploadMore(true);
  };

  const handlePendingClick = () => {
    setTopicsTab("pending");
  };

  const handleRetryClick = async (item) => {
    const objToPass = {
      IBO: parseInt(item.IBO),
      ContactId: parseInt(item.ContactId),
      FileName: item.FileName,
    };

    // await fakeApiCall(3000);
    await retryUploadForItem.mutateAsync(objToPass);
    refetchUploadedAudioFiles();
    setRootLoading(false);
  };

  useEffect(async () => {
    if (topicsTab === "pending") {
      refetchUploadedAudioFiles();
    }
  }, [topicsTab]);

  const isIboSelected = selectedUsers.length > 0;

  //DEVELOPMENT STUFF
  // const fakeApiCall = (delay = 3000) => {
  //   //10 second fake api call
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve({ message: 'fake api response after delay' });
  //     }, delay);
  //   });
  // };
  const isAllSelectedUsersDisabled = selectedUsers.every(
    (userId) => !usersData.find((u) => u.userId === userId)?.topicsActivated
  );
  return (
    <div className={styles.container}>
      <Header header={t("Settings")} onClick={handleHeaderBackClick} />

      <div className={styles.tabsRow}>
        <button
          className={classNames(
            topicsTab === "upload" && styles.activeTab,
            styles.tabItem
          )}
          onClick={() => setTopicsTab("upload")}
          disabled={processingRequest}
        >
          {t("Upload Files")}
        </button>
        <button
          className={classNames(
            topicsTab === "pending" && styles.activeTab,
            styles.tabItem
          )}
          onClick={() => setTopicsTab("pending")}
          disabled={processingRequest}
        >
          {t("Pending Uploads")}
        </button>
      </div>
      {/* TAB 1 */}
      {topicsTab === "upload" ? (
        <>
          <div className={styles.iconsContainer}>
            <div className={styles.icon1}>
              <img src={group1} alt="Group 1" className={styles.icon} />
            </div>
            <img src={group2} alt="Group 2" className={styles.icon} />
            {/* Remove Dreamstream per branding guidelines from Miguel */}
            {/* <img
              src={group3}
              alt="Group 3"
              className={`${styles.icon} ${styles.iconRight}`}
            /> */}
          </div>
          <div className={styles.uploadText}>
            {/* Remove Dreamstream per branding guidelines from Miguel */}
            {t("Upload your audio files to Topics")}
            {/*  by DreamStream® */}
          </div>
          <div className={styles.uploadTextBorder}></div>

          {processingRequest ? (
            <div className={styles.processingContainer}>
              <div className={styles.processingText}>
                {t("Please do not close or refresh the page")}
              </div>
              <div className={styles.processingLoaderContainer}>
                <Loader color={"#415364"} size={85} />
              </div>
            </div>
          ) : !uploadMore ? (
            <div className={styles.uploadedContainer}>
              {incorrectFiles.length > 0 ? (
                <>
                  <div className={styles.uploadedText}>
                    {t("The following files were rejected due to")}
                  </div>
                  <div className={styles.noteText}>
                    {t("At this time we are only accepting")}
                  </div>
                  <div className={styles.uploadedDropdownRow}>
                    <div>{t("Invalid Type")}</div>
                    <div className={styles.chevron}>
                      {invalidFileTypeDropdown ? (
                        <>
                          <ChevronDown
                            className={styles.dropdownArrow}
                            onClick={handleInvalidFileTypeDropdownClick}
                          />
                        </>
                      ) : (
                        <>
                          <ChevronRight
                            className={styles.dropdownArrow}
                            onClick={handleInvalidFileTypeDropdownClick}
                          />
                        </>
                      )}
                    </div>
                  </div>
                  {invalidFileTypeDropdown ? (
                    <div>
                      <div className={styles.dropdownContainer}>
                        <div className={classNames(styles.dropdownItemHeaders)}>
                          <div
                            className={classNames(
                              styles.dropdownCol,
                              styles.status,
                              styles.headerBorder
                            )}
                          >
                            {" "}
                          </div>
                          <div
                            className={classNames(
                              styles.dropdownCol,
                              styles.fileName,
                              styles.headerBorder
                            )}
                          >
                            {t("File Name")}
                          </div>
                          <div
                            className={classNames(
                              styles.dropdownCol,
                              styles.fileType,
                              styles.headerBorder
                            )}
                          >
                            {t("File Type")}
                          </div>
                        </div>
                        {incorrectFiles.length > 0
                          ? incorrectFiles.map((item, index) => {
                              return (
                                <div
                                  className={styles.dropdownItem}
                                  key={index}
                                >
                                  <div
                                    className={classNames(
                                      styles.dropdownCol,
                                      styles.status
                                    )}
                                  >
                                    X
                                  </div>
                                  <div
                                    className={classNames(
                                      styles.dropdownCol,
                                      styles.fileName
                                    )}
                                  >
                                    {item.name}
                                  </div>
                                  <div
                                    className={classNames(
                                      styles.dropdownCol,
                                      styles.fileType
                                    )}
                                  >
                                    {item.type}
                                  </div>
                                </div>
                              );
                            })
                          : null}
                      </div>
                    </div>
                  ) : null}
                </>
              ) : null}

              {failedUploadFiles.length > 0 ? (
                <>
                  <div className={styles.uploadedText}>
                    {t("The following files failed to upload")}
                  </div>
                  <div className={styles.noteText}>
                    {t("You will need to reselect and re-upload these items")}
                  </div>
                  <div className={styles.uploadedDropdownRow}>
                    <div>{t("Upload Failed")}</div>
                    <div className={styles.chevron}>
                      {failedUploadDropdown ? (
                        <>
                          <ChevronDown
                            className={styles.dropdownArrow}
                            onClick={handleFailedDropdownClick}
                          />
                        </>
                      ) : (
                        <>
                          <ChevronRight
                            className={styles.dropdownArrow}
                            onClick={handleFailedDropdownClick}
                          />
                        </>
                      )}
                    </div>
                  </div>
                  {failedUploadDropdown ? (
                    <div>
                      <div className={styles.dropdownContainer}>
                        <div className={classNames(styles.dropdownItemHeaders)}>
                          <div
                            className={classNames(
                              styles.dropdownCol,
                              styles.status,
                              styles.headerBorder
                            )}
                          >
                            {" "}
                          </div>
                          <div
                            className={classNames(
                              styles.dropdownCol,
                              styles.fileName,
                              styles.headerBorder
                            )}
                          >
                            {t("File Name")}
                          </div>
                          <div
                            className={classNames(
                              styles.dropdownCol,
                              styles.fileUser,
                              styles.headerBorder
                            )}
                          >
                            {t("User")}
                          </div>
                        </div>
                        {failedUploadFiles.length > 0
                          ? failedUploadFiles.map((item, index) => {
                              let splitContactId =
                                item.audioValue.name.split("-")[1];
                              const user = usersData.find(
                                (u) => u.contactId == splitContactId
                              );
                              const name = user ? user.strFirst : " ";
                              return (
                                <div
                                  className={styles.dropdownItem}
                                  key={index}
                                >
                                  <div
                                    className={classNames(
                                      styles.dropdownCol,
                                      styles.status
                                    )}
                                  >
                                    X
                                  </div>
                                  <div
                                    className={classNames(
                                      styles.dropdownCol,
                                      styles.fileName
                                    )}
                                  >
                                    {item.audioValue.originalFileName}
                                  </div>
                                  <div
                                    className={classNames(
                                      styles.dropdownCol,
                                      styles.fileUser
                                    )}
                                  >
                                    {name}
                                  </div>
                                </div>
                              );
                            })
                          : null}
                      </div>
                    </div>
                  ) : null}
                </>
              ) : null}

              <div className={styles.successContainer}>
                {t("To view your pending downloads please view")}
              </div>

              <div className={styles.actionButtonRow}>
                <Button
                  buttonText={t("Back To Upload")}
                  onClick={handleBackClick}
                  className={styles.backButton}
                  disabled={false}
                />
                <Button
                  buttonText={t("View Pending Uploads")}
                  onClick={handlePendingClick}
                  className={styles.pendingButton}
                  disabled={false}
                />
              </div>
            </div>
          ) : (
            <>
              {/* here */}
              <div className={styles.chooseText}>
                {t("Choose which accounts you would like to")}
              </div>
              {/* Update to correct verbiage per Figma */}
              <div className={styles.noteText}>
                {t("Audios will be uploaded to your")}
              </div>
              <div className={styles.usersList}>
                {usersData.map((user) => {
                  const formattedFirstName = user.strFirst
                    .toLowerCase()
                    .replace(/^\w/, (c) => c.toUpperCase());
                  const formattedLastName = user.strLast
                    .toLowerCase()
                    .replace(/^\w/, (c) => c.toUpperCase());
                  const isDisabled = !user.topicsActivated;

                  return (
                    <div
                      key={user.userId}
                      className={classNames(
                        styles.userItem,
                        isDisabled && styles.userItemDisabled
                      )}
                      onClick={() => handleUserCheckboxChange(user.userId)}
                    >
                      <div className={styles.checkboxContainer}>
                        <img
                          src={rectangle}
                          alt="Checkbox"
                          className={styles.rectangleIcon}
                        />
                        {selectedUsers.includes(user.userId) && !isDisabled && (
                          <img
                            src={check}
                            alt="Check"
                            className={styles.checkIcon}
                          />
                        )}
                      </div>
                      <label className={styles.userLabel}>
                        {formattedFirstName} {formattedLastName}
                      </label>
                    </div>
                  );
                })}

                {!isIboSelected && (
                  <div className={styles.errorMessage}>
                    {t("Please choose an IBO")}
                  </div>
                )}
                {isIboSelected && (
                  <div>
                    <div
                      className={classNames(
                        styles.uploadButton,
                        isAllSelectedUsersDisabled &&
                          styles.uploadButtonDisabled
                      )}
                      onClick={handleUploadClick}
                    >
                      <img src={upload} alt="Upload button" />
                    </div>
                    <div className={styles.chooseFileText}>
                      {t("Choose Audio File")}
                    </div>
                  </div>
                )}

                {oversizeFiles.length > 0 && (
                  <div className={styles.oversizeErrorContainer}>
                    <div className={styles.uploadedTextFileError}>
                      {t("The following files are too large")}
                    </div>
                    <ul className={styles.oversizeList}>
                      {oversizeFiles.map((file, index) => (
                        <li key={index}>
                          {file.name} ({(file.size / (1024 * 1024)).toFixed(1)}{" "}
                          MB)
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              {/* here */}
            </>
          )}

          <input
            type="file"
            ref={fileInputRef}
            className={styles.fileInput}
            onChange={handleUploadFiles}
            accept=".mp3"
            multiple
          />

          {uploadStatus === "fail" && (
            <>
              <div className={styles.uploadBorder}></div>
              <div className={styles.uploadResult}>
                <img
                  src={uploadFail}
                  alt="Upload Failed"
                  className={styles.resultIcon}
                />
                <div className={styles.resultTextFail}>Uh-oh!</div>
                <div className={styles.resultText}>
                  {t("Something went wrong. Please try again")}
                </div>
              </div>
            </>
          )}
          {/* TAB 1 END */}
        </>
      ) : (
        <>
          {/* TAB 2 */}
          <div className={styles.iconsContainer}>
            <div className={styles.icon1}>
              <img src={group1} alt="Group 1" className={styles.icon} />
            </div>
            <img src={group2} alt="Group 2" className={styles.icon} />
            {/* Remove Dreamstream per branding guidelines from Miguel */}
            {/* <img
              src={group3}
              alt="Group 3"
              className={`${styles.icon} ${styles.iconRight}`}
            /> */}
          </div>
          {/* Remove Dreamstream per branding guidelines from Miguel */}
          <div className={styles.uploadText}>
            {t("Your List of pending upload files")}{/*  by DreamStream® */}
          </div>
          <div className={styles.uploadTextBorder}></div>

          {uploadedAudioFilesLoading ||
          refetchingUploadedAudioFilesLoading ||
          rootLoading ? (
            <div className={styles.processingLoaderContainer}>
              <Loader color={"#415364"} size={85} />
            </div>
          ) : (
            <div className={styles.userUploadsContainer}>
              <div className={classNames(styles.userUploadsItemHeaders)}>
                <div
                  className={classNames(
                    styles.uploadsCol,
                    styles.uploadFileUser,
                    styles.headerBorder
                  )}
                >
                  {t("User")}
                </div>
                <div
                  className={classNames(
                    styles.uploadsCol,
                    styles.uploadFileName,
                    styles.headerBorder
                  )}
                >
                  {t("File Name")}
                </div>
                <div
                  className={classNames(
                    styles.uploadsCol,
                    styles.uploadStatus,
                    styles.headerBorder
                  )}
                >
                  {t("Status")}
                </div>
              </div>
              {uploadedAudioFiles && uploadedAudioFiles.length > 0
                ? uploadedAudioFiles.map((item, index) => {
                    //need backend to return just the file name still (needs column added to table)
                    const user = usersData.find(
                      (u) => u.contactId == item.ContactId
                    );
                    const name = user ? user.strFirst : " ";
                    let status = item.RecordStatus;

                    // if (index == 1) {
                    //   status = 3
                    // }

                    return (
                      <div className={styles.uploadItem} key={index}>
                        <div
                          className={classNames(
                            styles.uploadsCol,
                            styles.uploadFileUser
                          )}
                        >
                          {name}
                        </div>
                        <div
                          className={classNames(
                            styles.uploadsCol,
                            styles.uploadFileName
                          )}
                        >
                          {item.FileTitle}
                        </div>
                        <div
                          className={classNames(
                            styles.uploadsCol,
                            styles.uploadStatus
                          )}
                        >
                          {status == 1 && (
                            // pending
                            <div className={styles.uploadPending}>{t("Pending")}</div>
                          )}
                          {status == 2 && (
                            // success
                            <div className={styles.uploadSuccess}>
                              {t("Successful")}
                            </div>
                          )}
                          {status == 3 && (
                            // success
                            <div
                              className={styles.uploadFailed}
                              onClick={() => {
                                setRootLoading(true);
                                handleRetryClick(item);
                              }}
                            >
                              <div className={styles.refreshIconContainer}>
                                <Refresh size={30} color="#EF4444" />
                              </div>
                              <div>{t("Retry")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })
                : null}
            </div>
          )}
          {/* TAB 2 END */}
        </>
      )}
    </div>
  );
}

export default TopicsPage;
